export default "__VITE_ASSET__D9n7OIVm__"